import React, { PropsWithChildren } from 'react';
import { ChevronRight, ChevronLeft } from 'react-bootstrap-icons';

import { StyledProp, styled, css } from '@/styled';

interface IProps extends StyledProp {
  id?: string;
  swiperRef: React.RefObject<any>;
  side: 'left' | 'right';
}

const CarouselNavigator = ({ swiperRef, side, className, children, id }: PropsWithChildren<IProps>) => {
  const onClick = () => {
    const mapper = {
      left: () => swiperRef.current?.swiper.slidePrev(),
      right: () => swiperRef.current?.swiper.slideNext()
    };

    mapper[side]();
  };

  return (
    <div id={id} className={className} onClick={onClick}>
      <div
        className={'carouselNavigator-container carouselNavigator-' + side}
        style={{ minHeight: 'calc(100% - 24px - 1rem)' }}
      >
        {children}
        {side === 'left' && <ChevronLeft className='carouselNavigator-svg' />}
        {side === 'right' && <ChevronRight className='carouselNavigator-svg' />}
      </div>
    </div>
  );
};
export default styled(CarouselNavigator)(
  ({ theme }) => css`
    .carouselNavigator-container {
      position: absolute;
      width: 5vw;
      min-width: 32px;
      top: 0;
      display: flex;
      align-items: center;
      z-index: 2;
      cursor: pointer;

      &:hover svg {
        transform: scale(1.1);
      }
    }

    .carouselNavigator-svg {
      transition: ${theme.motionDurationMid};
      font-size: ${theme.space.pxToRem(48)};
      color: ${theme.colorIcon};
    }

    ${theme.breakpoints.down('sm')} {
      .carouselNavigator-container {
        width: 17vw;
      }

      .carouselNavigator-svg {
        font-size: 3rem;
      }
    }

    .carouselNavigator-left {
      left: 0;
      background: linear-gradient(
        90deg,
        ${theme.colorBgBase} 0%,
        ${theme.palette.alpha(theme.palette.gray[11], 0)} 100%
      );
      justify-content: start;
    }

    .carouselNavigator-right {
      right: 0;
      background: linear-gradient(
        270deg,
        ${theme.colorBgBase} 0%,
        ${theme.palette.alpha(theme.palette.gray[11], 0)} 100%
      );
      justify-content: end;
    }
  `
);
